export const mimeTypeMap = {
    'application/msexcel': 'xls'
}